import { createUserManager } from "redux-oidc";
import { config } from "../components/auth/logisticsConfig";

const userManager = createUserManager(config);
export default userManager;
